.avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: var(--tuna-shape-radius-circle);
  overflow: hidden;
  background-color: var(--tuna-palette-grey-400);
  color: var(--tuna-palette-background-default);
  font-size: var(--tuna-typography-fontSize-2xl);
  flex-shrink: 0;
  user-select: none;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.small {
  width: 24px;
  height: 24px;
  font-size: var(--tuna-typography-fontSize-xs);
}

.large {
  width: 56px;
  height: 56px;
  font-size: var(--tuna-typography-fontSize-3xl);
}
